import { Box, IconButton, Button, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PreviewIcon from "@mui/icons-material/Preview";
import moment from "moment";

export const HeaderConfig = [
  {
    label: "Sl No.",
    id: "siNo",
  },
  {
    label: "Module Name",
    id: "name",
    render: (data) => <Typography>{data?.name}</Typography>,
  },
  {
    label: "Agenda",
    id: "attachment",
    render: (data) => (
      <Button
        variant="text"
        onClick={() => window.open(data.attachment, "_blank")}
        size="small"
      >
        View Agenda
      </Button>
    ),
  },

  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("EDIT", data)}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton onClick={() => onClick("DELETE", data)}>
          <DeleteIcon color="error" />
        </IconButton>
      </Box>
    ),
  },
];

export const getKnowledgeSharingFormConfig = () => [
  {
    name: "name",
    type: "text",
    label: "Module Name",
    placeholder: "Enter Module Name",
    required: true,
  },
  // {
  //   name: "document",
  //   type: "file",
  //   label: "Document",
  //   placeholder: "Upload Document",
  //   required: true,
  //   accept: ".pdf,.doc,.docx",
  // },
];
